import { defineStore } from 'pinia';

type PaymentProvider = 'chargebee' | 'round';

interface KegelGatewayStateModel {
  beid: string
  gid: string
  gn: string
  spk: string
  pgid: string
  pgn: string
  hp: string
  fbp: string
  fbc: string
  ttclid: string
  provider: PaymentProvider
  subscriptionService: string
  providerResolved: boolean
  railLocked: boolean
  lagoPaypalClientId: string
  lagoHyperswitchPk: string
  lagoCardProvider: string
  isSimpleEmailPageForAndroid: '1' | '0'
}

export const useKegelGatewayStore = defineStore('kegelGateway', {
  state: (): KegelGatewayStateModel => ({
    beid: '',
    gid: '',
    gn: '',
    spk: '',
    pgid: '',
    pgn: '',
    hp: '',
    fbp: '',
    fbc: '',
    ttclid: '',
    provider: 'chargebee',
    subscriptionService: 'chargebee',
    providerResolved: false,
    railLocked: false,
    lagoPaypalClientId: '',
    lagoHyperswitchPk: '',
    lagoCardProvider: '',
    isSimpleEmailPageForAndroid: '0',
  }),

  getters: {
    isGatewayReady: (state): boolean =>
      !!(state.beid && state.gid && state.gn && state.spk && state.pgid && state.pgn),
  },

  persist: {
    beid: { query: 'beid', local: 'beid' },
    gid: { query: 'gid', local: 'gid' },
    gn: { query: 'gn', local: 'gn' },
    spk: { query: 'spk', local: 'spk' },
    pgid: { query: 'pgid', local: 'pgid' },
    pgn: { query: 'pgn', local: 'pgn' },
    hp: { local: 'hp' },
    fbp: { local: 'rtk_fbp' },
    fbc: { local: 'rtk_fbc' },
    ttclid: { local: 'rtk_ttclid' },
    provider: { local: 'payment_provider' },
    subscriptionService: { local: 'subscription_service' },
    lagoPaypalClientId: { local: 'lago_paypal_client_id' },
    lagoHyperswitchPk: { local: 'lago_hyperswitch_p_key' },
    lagoCardProvider: { local: 'lago_card_provider' },
    isSimpleEmailPageForAndroid: { local: 'is_simple_email_page_for_android', query: 'se' },
  },
});
